import { createElement } from "react";
/**
 * External Dependencies
 */
import classnames from 'classnames';
import { css } from 'emotion';

/**
 * Internal Dependencies
 */
import useBlockTheme from '../../hooks/use-block-theme';
import HTMLParser from '../html-parser';
import { __experimentalUseFieldRenderContext } from '..';
const ErrorMsgWrapper = ({
  message
}) => {
  const {
    attributes
  } = __experimentalUseFieldRenderContext();
  const theme = useBlockTheme(attributes?.themeId);
  return createElement("div", {
    className: classnames('renderer-components-error-message-wrapper', css`
					background: ${theme.errorsBgColor};
					color: ${theme.errorsFontColor};
				`)
  }, createElement(HTMLParser, {
    value: message
  }));
};
export default ErrorMsgWrapper;
//# sourceMappingURL=index.js.map